import React from 'react';
import { Card, CardContent, Box, Typography } from '@mui/material';

const EventCard = ({ image, title, description, onClick }) => {
  return (
    <Card
      sx={{
        textAlign: 'center',
        p: 2,
        height: '100%',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: 3,
          transform: 'translateY(-2px)',
        },
      }}
      onClick={onClick}
    >
      <CardContent sx={{px:1}}>
        <img src={process.env.REACT_APP_API_URL.concat(image)} alt="Affiche projet" height={250} style={{objectFit:'contain'}} />
        <Typography variant="h6" component="h3" gutterBottom>
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default EventCard;